import { createContext, useContext, useEffect, useReducer } from "react";
import { Navigate } from "react-router-dom";
import { GET_ACCOUNT, SIGN_IN, SIGN_UP } from "../../utils/API";
import {
  CHECKAUTH,
  LOGIN,
  LOGOUT,
  REGISTER,
  SETSTORAGE,
  SET_ACCOUNT,
  SET_IMAGE,
  SET_POSTS,
} from "../actions/auth.action";
import reducer from "../reducers/AuthReducer";
import { useUIContext } from "./ui.context";

const AuthContext = createContext();
const initialState = {
  isLogged: false,
  token: "",
  data: {},
  posts: [],
};

export const AuthProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);
  const { loadingEnd, loadingStart } = useUIContext();

  const getAccount = (token) => {
    fetch("https://mediumuz.herokuapp.com/api/account/get-my-data", {
      headers: {
        Authorization: `bearer ${token}`,
      },
    })
      .then((response) => (response.ok ? response.json() : ""))
      .then((result) => dispatch({ type: SET_ACCOUNT, payload: result }))
      .catch((error) => console.log("error", error));
  };
  const uploadPhoto = async (formData) => {
    loadingStart();
    await fetch("https://mediumuz.herokuapp.com/api/account/upload-image", {
      method: "PATCH",
      body: formData,
      headers: {
        Authorization: `bearer ${state.token}`,
      },
    })
      .then((response) => (response.ok ? response.json() : ""))
      .then((result) => dispatch({ type: SET_IMAGE, payload: result }))
      .catch((error) => console.log("error", error));
    loadingEnd();
  };

  const updateAccount = async (data) => {
    loadingStart();
    await fetch("https://mediumuz.herokuapp.com/api/account/update", {
      method: "PUT",
      headers: {
        Authorization: `bearer ${state.token}`,
      },
      body: JSON.stringify(data),
    })
      .then((response) => (response.ok ? response.json() : ""))
      .then((result) => console.log(result))
      .then((result) => getAccount(state.token))
      .catch((error) => console.log("error", error));
    loadingEnd();
  };

  const getPosts = async () => {
    loadingStart();
    await fetch(
      "https://mediumuz.herokuapp.com/api/account/get-my-post?offset=0&limit=100",
      {
        headers: {
          Authorization: `bearer ${state.token}`,
        },
      }
    )
      .then((response) => (response.ok ? response.json() : ""))
      .then((result) => dispatch({ type: SET_POSTS, payload: result }))
      .catch((error) => console.log("error", error));
    loadingEnd();
  };

  const createPost = async (data, img) => {
    loadingStart();
    await fetch("https://mediumuz.herokuapp.com/api/post/create", {
      method: "POST",
      headers: {
        Authorization: `bearer ${state.token}`,
      },
      body: JSON.stringify(data),
    })
      .then((response) => (response.ok ? response.json() : Error(response)))
      .then(async (result) => {
        const form = new FormData();
        form.append("file", img);
        return await fetch(
          "https://mediumuz.herokuapp.com/api/post/upload-image?id=" +
            result.data,
          {
            method: "PATCH",
            body: form,
            headers: {
              Authorization: `bearer ${state.token}`,
            },
          }
        )
          .then((response) => (response.ok ? response.json() : ""))
          .then((result) => console.log(result))
          .catch((error) => console.log("error", error));
      })
      .catch((error) => console.log("error", error));
    loadingEnd();
  };

  const updatePost = () => {
    let myHeaders = new Headers();
    myHeaders.append(
      "Authorization",
      "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJleHAiOjE2NTQ3MjMxMzIsImlhdCI6MTY1NDY3OTkzMiwidXNlcl9pZCI6Nn0.atowaXKfL6rvijmSSdZEGobgCFueB4X8rX4jUNPG8UE"
    );

    let requestOptions = {
      method: "POST",
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(
      "https://mediumuz.herokuapp.com/api/account/update?id=6",
      requestOptions
    )
      .then((response) => response.text())
      .then((result) => console.log(result))
      .catch((error) => console.log("error", error));
  };

  const signIn = async (email, password) => {
    loadingStart();
    return await fetch(SIGN_IN, {
      method: "POST",
      body: JSON.stringify({ email: email, password: password }),
    })
      .then(async (data) => {
        if (data.status === 200) {
          const res = await data.json();
          dispatch({ type: LOGIN, payload: res });
          dispatch({ type: SETSTORAGE, payload: res });
          getAccount(res.token);
          loadingEnd();
        } else {
          loadingEnd();
          return data.json();
        }
      })
      .catch((e) => {
        loadingEnd();
        return e.json();
      });
  };

  const signUp = async (email, password, nick) => {
    loadingStart();
    return await fetch(SIGN_UP, {
      method: "POST",
      body: JSON.stringify({
        email: email,
        nickname: nick,
        password: password,
      }),
      redirect: "follow",
    })
      .then(async (data) => {
        if (data.status === 200) {
          const res = await data.json();
          dispatch({ type: REGISTER, payload: res });
          dispatch({ type: SETSTORAGE, payload: res });
          getAccount(res.token);
          loadingEnd();
        } else {
          loadingEnd();
          return data.json();
        }
      })
      .catch((e) => {
        loadingEnd();
        return e;
      });
  };

  const logout = () => {
    dispatch({ type: LOGOUT, payload: initialState });
  };

  const checkEmail = async (email) => {
    loadingStart();
    return await fetch(
      `https://mediumuz.herokuapp.com/auth/recovery-check?email=${email}`
    )
      .then((data) => {
        loadingEnd();
        return data.status === 200;
      })
      .catch((e) => {
        loadingEnd();
        console.log(e);
      });
  };

  const sendCode = (email) => {
    loadingStart();
    fetch(`https://mediumuz.herokuapp.com/auth/recovery-send?email=${email}`)
      .then((data) => {
        loadingEnd();
        return data.status === 200;
      })
      .catch((e) => {
        loadingEnd();
        console.log(e);
      });
  };
  const sendVerifyCode = async () => {
    loadingStart();
    return await fetch(`https://mediumuz.herokuapp.com/api/account/sendcode`, {
      headers: {
        Authorization: `bearer ${state.token}`,
      },
    })
      .then((data) => {
        loadingEnd();
        return data.status === 200;
      })
      .catch((e) => {
        loadingEnd();
        return console.log(e);
      });
  };

  const verifyCode = async (email, code) => {
    loadingStart();
    return await fetch(
      `https://mediumuz.herokuapp.com/auth/recovery-verify?email=${email}&code=${code}`
    )
      .then((data) => {
        loadingEnd();
        return data.status === 200;
      })
      .catch((e) => {
        loadingEnd();
        console.log(e);
      });
  };
  const checkAccountVerify = async (code) => {
    loadingStart();
    return await fetch(
      `https://mediumuz.herokuapp.com/api/account/verify?code=${code}`,
      {
        headers: {
          Authorization: `bearer ${state.token}`,
        },
      }
    )
      .then((data) => {
        loadingEnd();
        return data.status === 200;
      })
      .catch((e) => {
        loadingEnd();
        console.log(e);
      });
  };

  const changePassword = async (email, password) => {
    loadingStart();
    return await fetch(
      `https://mediumuz.herokuapp.com/auth/recovery-password?email=${email}&password=${password}`
    )
      .then((data) => {
        loadingEnd();
        return data.status === 200;
      })
      .catch((e) => {
        loadingEnd();
        console.log(e);
      });
  };

  useEffect(() => {
    const token = localStorage.getItem("token");
    const exp = localStorage.getItem("exp");
    if (token && token !== "undefined" && exp && +exp > new Date().getTime()) {
      dispatch({ type: LOGIN, payload: { token } });
      getAccount(token);
    } else {
      logout();
    }
    loadingEnd();
  }, []);

  return (
    <AuthContext.Provider
      value={{
        ...state,
        signIn,
        signUp,
        checkEmail,
        sendCode,
        verifyCode,
        changePassword,
        uploadPhoto,
        updateAccount,
        sendVerifyCode,
        checkAccountVerify,
        createPost,
        createPost,
        getPosts,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const UseAuthContext = () => useContext(AuthContext);
